import { UserStatusType } from 'features/auth/helpers/getStatusType'
import { UserProfile } from 'features/share/types'
import { eventMonitoring } from 'libs/monitoring/services'

type LogHeaderFallbackParams = {
  user: UserProfile
  headerType: UserStatusType
}

export const logHeaderFallback = ({ user, headerType }: LogHeaderFallbackParams) => {
  eventMonitoring.captureException('Profile V2 - Header fallback', {
    level: 'info',
    extra: { user, headerType },
  })
}
